export const MARK_PATHWAY_COMPLETE_REQUEST = "MARK_PATHWAY_COMPLETE_REQUEST";
export const MARK_PATHWAY_COMPLETE_RECEIVE = "MARK_PATHWAY_COMPLETE_RECEIVE";
export const MARK_PATHWAY_COMPLETE_FAILURE = "MARK_PATHWAY_COMPLETE_FAILURE";
export const RESET_MARK_PATHWAY_COMPLETE = "RESET_MARK_PATHWAY_COMPLETE";
